const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  PRODUCT_LIST:'PRODUCT_LIST',
  PRODUCT_LIST_RESULT:'PRODUCT_LIST_RESULT',
  PRODUCT_FETCH_ID:'PRODUCT_FETCH_ID',
  PRODUCT_FETCH_LIST_ID:'PRODUCT_FETCH_LIST_ID',
  PRODUCT_EDIT_BY_MGC:'PRODUCT_EDIT_BY_MGC',
  PRODUCT_NUT_EDIT_BY_ID: 'PRODUCT_NUT_EDIT_BY_ID',



  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  ProductRead:(info)=>({
      type: actions.PRODUCT_LIST,
      payload:{info,page:1}
  }),
  onPageChange: (info, page) => ({
    type: actions.PRODUCT_LIST,
    payload: { info, page }
  }),
  ProductListSuccess: (exportresult,result,success,total_count,page) => ({
   type: actions.PRODUCT_LIST_RESULT,
   exportresult,
   result,
   success,
   total_count,
   page
 }),
 ProductfetchBYId:(listid)=>({
   type: actions.PRODUCT_FETCH_ID,
   payload:{listid}
 }),
 ProductListById: (result,success) => ({
  type: actions.PRODUCT_FETCH_LIST_ID,
  result,
  success
}),
};
export default actions;
